<mat-form-field appearance="fill" style="width:100%;">
    <textarea matInput [(ngModel)]="data" style="width:100%; height:10em;"></textarea>
</mat-form-field>

<mat-slide-toggle [(ngModel)]="doAllowances">Update Allowances</mat-slide-toggle><br />
<br />

<!-- <button mat-raised-button color="secondary" (click)="parseShipment()">Parse & Log it</button> -->
<button mat-raised-button color="primary" (click)="processRepSO()">Update It</button>

<div>{{feedback}}</div>